import { render, staticRenderFns } from "./ShopStoreAlbum.vue?vue&type=template&id=479373de&scoped=true"
import script from "./ShopStoreAlbum.vue?vue&type=script&lang=js"
export * from "./ShopStoreAlbum.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreAlbum.vue?vue&type=style&index=0&id=479373de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479373de",
  null
  
)

export default component.exports